export const SnapshotGenerated = 'Ledger snapshot generated';
export const InsightsGenerated = 'Insights generated';

export const events = Object.freeze({
  membershipUpgraded: 'entity/membership/upgraded',
  casePaid: 'payment/completed',
  snapshotGenerated: 'entity/snapshot/generated',
  ledgerSnapshotGeneration: 'entity/ledger/snapshot/generation',
  matchResultUpdate: 'funding/match/status_update',
});
